'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_bwcu1_1";
const list = "_list_bwcu1_14";
const item = "_item_bwcu1_25";
const styles = {
	root: root,
	list: list,
	item: item
};

const Breadcrumbs = ({ children, size = "large" }) => {
  const iconSize = {
    small: 20,
    large: 24
  }[size];
  const items = React.Children.toArray(children).filter(Boolean).map((link, i, links) => {
    const icon = i !== links.length - 1 && React__default.default.createElement(
      "span",
      { "aria-hidden": "true", "data-zds": true },
      React__default.default.createElement(components_display_Icon_Icon.Icon, { isBlock: true, color: "GrayWarm4", name: "arrowSmallRight", size: iconSize })
    );
    return React__default.default.createElement(
      "li",
      { className: styles.item, key: i, "data-zds": true },
      link,
      icon
    );
  });
  return React__default.default.createElement(
    "div",
    { className: styles.root, "data-size": size, "data-zds": true },
    React__default.default.createElement("ol", { className: styles.list, "data-zds": true }, items)
  );
};

exports.Breadcrumbs = Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.cjs.js.map
